import BaseModel from "./BaseModel";
import { copyAllProperties } from "./utils";
import BaseObject from "./BaseObject";
import RootTreeViewModel from "../modelTreeViews/RootTreeviewModel";
import Logger from "../Logger";

const logger = new Logger();

export default class Root extends BaseModel {
  public get className(): string {
    return "Root"; // no itx
  }

  constructor(data?: any, parent?: BaseObject) {
    super(data, parent);
    this.treeViewModel = new RootTreeViewModel(this);
    copyAllProperties(data, this);
  }
  //////////////////////////////////////////////////////
  ///////////// for paste
  async pasteItem(params: { item: BaseModel; allItems: Array<BaseModel> }): Promise<Array<BaseModel>> {
    const { item } = params;

    if (item.className == "Floor") {
      var res: Array<BaseModel> = await item.executePaste({
        parent: this,
        isCopyRootObj: true,
      });
      item.updateTagInPaste(state.floors);
      return res;
    } else if (item.className == "Cabinet") {
      var res: Array<BaseModel> = await item.executePaste({
        parent: this,
        isCopyRootObj: true,
      });
      item.updateTagInPaste(state.cabinets);
      return res;
    } else {
      logger.error(`unsuported class in paste Item Root ${item.className}`);
    }

    return [];
  }
}
